import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

const get = function ($, partnerId = null) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/activity/partner-cards${partnerId ? "/" + partnerId : "" + ""}`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}


const create = function ($, pcsDsi) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/activity/partner-cards`, pcsDsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const validate = function ($, projectId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/activity/partner-cards/${projectId}/validate`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, partnerId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/activity/partner-cards/${partnerId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, partnerId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/activity/partner-cards/${partnerId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}


export default {
  get,
  create,
  update,
  remove,
  close,
  validate
}
